import { useState } from 'react'
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { REGISTER_NEW_ORGANIZATIONAL_USER_QUERY } from '../services/GraphQLQueries';
import LogoMark from '../assets/Logomark.png';
import SideMenu from '../layouts/SideMenu';
import '../layouts/stylesheets/loader-style.css';

export default function SignUpOrgUser() {
    const [registerNewOrgUser, { loading }] = useMutation(REGISTER_NEW_ORGANIZATIONAL_USER_QUERY);
    const [stateLoading, setLoading] = useState(false)
    const key = new URLSearchParams(window.location.search).get('resetkey');
    console.log("key:", key);
    const [signupForm, setSignupForm] = useState({
        resetToken: key,
        fullname: '',
        password: '',
    });
    const navigate = useNavigate();

    const handleChange = (event) => {
        setSignupForm({ ...signupForm, [event.target.id]: event.target.value });
    }
    const [formErrors, setFormErrors] = useState({ errors: {} });
    const handleLogin = async (e) => {
        e.preventDefault()
        let errors = {};
        let proceed = true;
        if (signupForm.password.length < 8) {
            errors.password = 'Password too short.';
            proceed = false;
        }
        if (signupForm.fullname.length < 3) {
            errors.fullname = 'Please enter your name.';
            proceed = false;
        }
        if (!proceed) {
            setFormErrors({ ...formErrors, errors });
            return;
        }

        try {
            setLoading(true)
            const { error } = "";
            if (error) throw error
            // alert('Check your email for the login link!')
            registerNewOrgUser({
                variables: signupForm, onCompleted: data => {
                    console.log("response:", data);
                    // if the login response succeeds
                    if (data?.registerNewOrganizationalUser?.id) {
                        navigate("/signin");
                    } else {
                        console.log("some error:", data?.registerNewOrganizationalUser?.error);
                        setFormErrors({ errors: { ...formErrors, password: data?.registerNewOrganizationalUser?.error } });
                    }
                }
            });
            // navigate("/FirstTracker/Main");
        } catch (error) {
            alert(error.error_description || error.message)
        } finally {
            setLoading(false)
        }
    }
    return (
        <div className="flex justify-center items-center" aria-live="polite">
            <SideMenu hideBackArrow></SideMenu>
            <div className="w-full flex justify-center">
                {loading || stateLoading ? <>
            <div className="loader-wrapper">
                <div className='flex justify-center items-center'>
                    <div className='grid gap-10'>
                        <div className="loader"></div>
                        <div className='text-center'>Registering...</div>
                    </div>
                </div>
            </div>
        </> : (
                    <div className='grid gap-6 md:w-96 w-72 mb-36'>
                        <div className='flex justify-center'>
                            <img className="w-[46px] h-[46px]" src={LogoMark} alt="LogoMark" />
                        </div>
                        <div className='flex justify-center'>
                            <h3 className='w-full text-3xl font-semibold text-gray-900 text-center'>Finish creating your account</h3>
                        </div>
                        <div className='flex justify-center'>
                            <h1 className='text-gray-600'>Join your organization now!</h1>
                        </div>
                        <div>
                            <p className='text-gray-700 text-sm font-medium mb-1'>Name*</p>
                            <input type="text" id="fullname"
                                className=" text-black border border-gray-300 placeholder-gray-500 rounded-md block w-full p-2"
                                placeholder="Enter your name" required
                                value={signupForm.fullname}
                                onChange={handleChange} />
                            {formErrors.errors.fullname ? <p style={{ color: '#f44', 'fontWeight': 'bold', 'textAlign': 'center' }}>{formErrors.errors.fullname}</p> : ''}
                        </div>
                        <div>
                            <p className='text-gray-700 text-sm font-medium mb-1'>Password*</p>
                            <input type="password" id="password"
                                className=" text-black border border-gray-300 placeholder-gray-500 block w-full p-2"
                                placeholder="Create a password" required
                                value={signupForm.password}
                                onChange={handleChange} />
                            <p className='text-gray-600 text-sm font-normal mt-1'>Must be at least 12 characters.</p>
                            {formErrors.errors.password ? <p style={{ color: '#f44', 'fontWeight': 'bold', 'textAlign': 'center' }}>{formErrors.errors.password}</p> : ''}
                        </div>
                        <input type="button" id="continue" onClick={handleLogin}
                            className="bg-onTrack-light-purple font-semibold text-white text-center rounded-md block w-full p-3"
                            placeholder="Get Started" value='Get Started' />
                        {/* <div type="button" id="continue" onClick={handleLogin}
                            className="border border-gray-300 font-semibold text-gray-700 text-center rounded-md w-full p-3"><FcGoogle className='inline h-6 w-6 mr-2'></FcGoogle>Sign up with Google</div> */}
                    </div>
                )}
            </div>
        </div>
    )
}
